import React, { useEffect, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './css/Login.css';
import toast from 'react-hot-toast';
import axios from './../axios';
import Spinner from '../components/Spinner';
 import { useNavigate } from 'react-router-dom';

function LoginPage() {
  const [userType, setUserType] = useState('Student');
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [is_Loading, setIsLoading]=useState(false);
      
const navigate = useNavigate();
useEffect(()=>{
  const token=localStorage.getItem('student_token');
if(token){
   navigate('/student/dashboard');

}
  const teacher=localStorage.getItem('staff');

if(teacher){
   navigate('/staff/dashboard');

}

},[])

  const handleSubmit = async (e) => {
    e.preventDefault();
try{
  setIsLoading(true);
  if(userType=='Student'){
const login = await axios.post('/student/login', {
    id:userId,
    password:password
   },
);
// console.log(login.data.student);
 localStorage.setItem("student_token", login.data.token);
 localStorage.setItem("student", JSON.stringify(login.data.student));
 localStorage.setItem("school", JSON.stringify(login.data.school));
 console.log(JSON.parse(localStorage.getItem('school')).school_name);
toast.success('Logged In Successfuly') ;
 navigate('/student/dashboard');
}else{

  // 

const login = await axios.get('/staff/login', {
  params:{
    id:userId,
    password:password}
   },
);
// console.log(login.data.student);
 localStorage.setItem("id", userId);
 localStorage.setItem("password", password);
  localStorage.setItem("school", JSON.stringify(login.data.school));
  localStorage.setItem("staff", JSON.stringify(login.data.staff));
//  toast.success('Logged In Successfuly') ;
 navigate('/staff/dashboard');
  // 
  toast.success('Teacher Logged In Successfuly') ;

}
// success
}catch(error){
 const errorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Error logining account';
          toast.error(errorMessage);
}finally{
  setIsLoading(false);
}
    console.log('Login Attempt:', { userType, userId, password });
   // navigate('/student/dashboard');
   };

  return (
    <div className="login-container">
      <div className="background-art">
        <div className="circle-top-left"></div>
        <div className="circle-top-right"></div>
      </div>
      <div className="login-box">
        <div style={{}}>
        <h1 className="login-title">Login Here</h1>
        <p className="login-subtitle">Sign in to your account</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="userType">User Type</label>
            <select
              id="userType"
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="Student">Student</option>
              <option value="Staff">Teacher</option>
            </select>
          </div>
          <div className="input-group">
            <label htmlFor="userId">User ID</label>
            <input
              id="userId"
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter your User ID"
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <div className="password-wrapper">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your Password"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>
          <button type="submit" className="login-button">
{is_Loading ? (
  <div style={{ display: 'flex', justifyContent:'center', alignItems: 'center', gap: '8px' }}>
    <Spinner />
    <span>Loading</span>
  </div>
) : 'Sign In'}
            </button>
        </form></div>
          <center>
            <img style={{width:200}} src="https://www.euroschoolindia.com/blogs/wp-content/uploads/2023/08/strategies-to-improve-student-learning.jpg"/>
           <hr/>  Designed with ❤️  by<br/> <a href="https://webspool.in"> WEBSPOOL PRIVATE LIMITED </a>
          </center>
      </div>
    
    </div>
  );
}

export default LoginPage;